const cartTypes = {
  DEFAULT: "default",
  EXPRESS_APPLE_PAY: "expressApplePay",
  EXPRESS_BUY_NOW: "expressBuyNow",
  EXPRESS_GOOGLE_PAY: "expressGooglePay",
  OTHER: "other"
};

const CLIENT_STORAGE_KEY = "lll-ngc-assets";

const channelTypes = {
  NA_APP: "na-app",
  NA_BBR: "na-bbr",
  NA_GEC: "na-gec",
  NA_WEB: "na-web"
};

const locales = {
  EN_US: "en_US",
  EN_CA: "en_CA",
  FR_CA: "fr_CA"
};

const cartScopes = {
  LOGGED_IN: "loggedin",
  ANONYMOUS: "anonymous"
};

const assetCategoryTypes = {
  CART: "cart",
  SHOPPING_LIST: "shoppingList",
  ALL: "all"
};

const assetActionTypes = {
  UPDATE: "update",
  REMOVE: "remove",
  REMOVE_ALL: "removeAll"
};

const FEATURE_NAME = "bag-client-sdk";

export {
  cartTypes,
  CLIENT_STORAGE_KEY,
  locales,
  channelTypes,
  assetCategoryTypes,
  cartScopes,
  FEATURE_NAME,
  assetActionTypes
};
